/** Endpoints affiliations (liens partenaires contextuels). */

import { apiFetch } from "@/api/client";

export type Affiliation = {
  partner_id: string;
  label: string;
  description: string;
  cta: string;
  url: string;
  is_official: boolean;
  disclosure_label: string;
};

export function listDefaultAffiliations() {
  return apiFetch<Affiliation[]>("/affiliations");
}

export function resolveAffiliations(improvements: string[], source = "scenario") {
  return apiFetch<Affiliation[]>("/affiliations/resolve", {
    method: "POST",
    body: { improvements, source },
  });
}
